// GEAR Collection Filters — attribute-first filtering with dynamic category narrowing

(function () {
  var PRICE_RANGES = [
    { id: 'price-under-5', label: 'Under $5', min: 0, max: 5, exclusiveMax: true },
    { id: 'price-5-10', label: '$5 - $10', min: 5, max: 10, exclusiveMax: true },
    { id: 'price-10-20', label: '$10 - $20', min: 10, max: 20, exclusiveMax: true },
    { id: 'price-20-50', label: '$20 - $50', min: 20, max: 50, exclusiveMax: false },
    { id: 'price-over-50', label: 'Over $50', min: 50, max: Infinity, exclusiveMax: false },
  ];

  var SIZE_ORDER = [
    'XS',
    'S',
    'M',
    'L',
    'XL',
    '2XL',
    '2XLARGE',
    'XXL',
    '3XL',
    '3XLARGE',
    'XXXL',
    '4XL',
    '4XLARGE',
  ];

  function normalizeSize(size) {
    return (size || '').trim().toUpperCase().replace(/\s+/g, '');
  }

  function parseList(value) {
    return (value || '')
      .split(',')
      .map(function (item) {
        return item.trim();
      })
      .filter(Boolean);
  }

  function getCards() {
    return Array.from(document.querySelectorAll('.gear-product-card'));
  }

  function getSelectedCategory() {
    var checked = document.querySelector('.gear-filter__checkbox--category:checked');
    if (!checked) return null;
    return {
      handle: checked.id.replace('cat-', ''),
      label: checked.dataset.label || checked.id.replace('cat-', ''),
    };
  }

  function getCheckedAttribute(type) {
    return Array.from(document.querySelectorAll('[data-filter-type="' + type + '"]:checked')).map(function (el) {
      return el.value;
    });
  }

  function getActiveFilters() {
    return {
      category: getSelectedCategory(),
      prices: getCheckedAttribute('price'),
      sizes: getCheckedAttribute('size'),
      colors: getCheckedAttribute('color'),
    };
  }

  function priceInRange(price, range) {
    if (range.max === Infinity) return price > range.min;
    if (range.exclusiveMax) return price >= range.min && price < range.max;
    return price >= range.min && price <= range.max;
  }

  function findPriceRange(id) {
    for (var i = 0; i < PRICE_RANGES.length; i++) {
      if (PRICE_RANGES[i].id === id) return PRICE_RANGES[i];
    }
    return null;
  }

  function getPriceRangeId(price) {
    for (var i = 0; i < PRICE_RANGES.length; i++) {
      if (priceInRange(price, PRICE_RANGES[i])) return PRICE_RANGES[i].id;
    }
    return null;
  }

  function cardMatchesCategory(card, catHandle) {
    if (!catHandle) return true;
    var handles = card.dataset.collections || '';
    return handles.indexOf(catHandle) !== -1;
  }

  function cardMatchesPrice(card, priceIds) {
    if (!priceIds.length) return true;
    var price = parseFloat(card.dataset.price || '0');
    return priceIds.some(function (id) {
      var range = findPriceRange(id);
      return range && priceInRange(price, range);
    });
  }

  function cardMatchesSize(card, sizes) {
    if (!sizes.length) return true;
    var cardSizes = parseList(card.dataset.sizes).map(normalizeSize);
    if (!cardSizes.length) return false;
    return sizes.some(function (size) {
      return cardSizes.indexOf(normalizeSize(size)) !== -1;
    });
  }

  function cardMatchesColor(card, colors) {
    if (!colors.length) return true;
    var cardColors = parseList(card.dataset.colors);
    if (!cardColors.length) return false;
    return colors.some(function (color) {
      return cardColors.indexOf(color) !== -1;
    });
  }

  function cardMatchesAttributeValue(card, type, value) {
    if (type === 'price') return cardMatchesPrice(card, [value]);
    if (type === 'size') return cardMatchesSize(card, [value]);
    if (type === 'color') return cardMatchesColor(card, [value]);
    return true;
  }

  function cardMatchesFilters(card, filters, excludeType) {
    if (excludeType !== 'category' && filters.category && !cardMatchesCategory(card, filters.category.handle)) {
      return false;
    }
    if (excludeType !== 'price' && !cardMatchesPrice(card, filters.prices)) return false;
    if (excludeType !== 'size' && !cardMatchesSize(card, filters.sizes)) return false;
    if (excludeType !== 'color' && !cardMatchesColor(card, filters.colors)) return false;
    return true;
  }

  function sortSizes(sizes) {
    return sizes.slice().sort(function (a, b) {
      var aNorm = normalizeSize(a);
      var bNorm = normalizeSize(b);
      var aIndex = SIZE_ORDER.indexOf(aNorm);
      var bIndex = SIZE_ORDER.indexOf(bNorm);
      if (aIndex === -1) aIndex = 999;
      if (bIndex === -1) bIndex = 999;
      if (aIndex !== bIndex) return aIndex - bIndex;
      return a.localeCompare(b);
    });
  }

  function analyzeProducts(cards) {
    var priceRangeIds = {};
    var sizes = {};
    var colors = {};

    cards.forEach(function (card) {
      var rangeId = getPriceRangeId(parseFloat(card.dataset.price || '0'));
      if (rangeId) priceRangeIds[rangeId] = true;

      parseList(card.dataset.sizes).forEach(function (size) {
        sizes[size] = true;
      });

      parseList(card.dataset.colors).forEach(function (color) {
        colors[color] = true;
      });
    });

    return {
      priceRangeIds: Object.keys(priceRangeIds),
      sizes: Object.keys(sizes),
      colors: Object.keys(colors),
    };
  }

  function slugify(value) {
    return value
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function buildFilterGroup(title, type, options) {
    var group = document.createElement('div');
    group.className = 'gear-filter-group';
    group.dataset.filterGroup = type;

    var heading = document.createElement('h3');
    heading.className = 'gear-filter__title';
    heading.innerHTML = title + ' <span class="gear-filter__toggle">›</span>';
    heading.addEventListener('click', function () {
      group.classList.toggle('collapsed');
    });

    var content = document.createElement('div');
    content.className = 'gear-filter__content';

    options.forEach(function (option) {
      var optionEl = document.createElement('div');
      optionEl.className = 'gear-filter__option';

      var input = document.createElement('input');
      input.type = 'checkbox';
      input.className = 'gear-filter__checkbox gear-filter__checkbox--attribute';
      input.dataset.filterType = type;
      input.id = type + '-' + option.id;
      input.value = option.value;

      var label = document.createElement('label');
      label.className = 'gear-filter__label';
      label.htmlFor = input.id;
      label.textContent = option.label;

      optionEl.appendChild(input);
      optionEl.appendChild(label);
      content.appendChild(optionEl);
    });

    group.appendChild(heading);
    group.appendChild(content);
    return group;
  }

  function buildAttributeFilters(cards) {
    var container = document.getElementById('gear-attribute-filters');
    if (!container) return;

    container.innerHTML = '';

    if (cards.length <= 1) {
      updateSidebarVisibility();
      return;
    }

    var analysis = analyzeProducts(cards);

    if (analysis.colors.length > 1) {
      var colorOptions = analysis.colors.sort(function (a, b) {
        return a.localeCompare(b);
      }).map(function (color) {
        return { id: slugify(color), value: color, label: color };
      });
      container.appendChild(buildFilterGroup('Color', 'color', colorOptions));
    }

    if (analysis.priceRangeIds.length > 1) {
      var priceOptions = [];
      PRICE_RANGES.forEach(function (range) {
        if (analysis.priceRangeIds.indexOf(range.id) !== -1) {
          priceOptions.push({
            id: range.id.replace('price-', ''),
            value: range.id,
            label: range.label,
          });
        }
      });
      container.appendChild(buildFilterGroup('Price', 'price', priceOptions));
    }

    if (analysis.sizes.length > 1) {
      var sizeOptions = sortSizes(analysis.sizes).map(function (size) {
        return { id: slugify(size), value: size, label: size };
      });
      container.appendChild(buildFilterGroup('Size', 'size', sizeOptions));
    }

    container.querySelectorAll('.gear-filter__checkbox--attribute').forEach(function (cb) {
      cb.addEventListener('change', onAttributeChange);
    });

    updateSidebarVisibility();
  }

  function updateCategoryVisibility(filters) {
    var categoryGroup = document.querySelector('.gear-filter-group--category');
    if (!categoryGroup) return;

    var cards = getCards();
    var visibleCount = 0;

    categoryGroup.querySelectorAll('.gear-filter__option').forEach(function (option) {
      var handle = option.dataset.catHandle;
      var input = option.querySelector('.gear-filter__checkbox--category');
      var matches = cards.some(function (card) {
        if (!cardMatchesFilters(card, filters, 'category')) return false;
        return cardMatchesCategory(card, handle);
      });

      var showOption = matches;
      option.hidden = !showOption;

      if (!showOption && input && input.checked) {
        input.checked = false;
      }

      if (showOption) visibleCount++;
    });

    categoryGroup.classList.toggle('gear-filter-group--empty', visibleCount === 0);
  }

  function updateAttributeVisibility(filters) {
    document.querySelectorAll('[data-filter-type]').forEach(function (input) {
      var type = input.dataset.filterType;
      var value = input.value;
      var option = input.closest('.gear-filter__option');
      if (!option) return;

      var matches = getCards().some(function (card) {
        if (!cardMatchesFilters(card, filters, type)) return false;
        return cardMatchesAttributeValue(card, type, value);
      });

      option.hidden = !matches;
    });

    document.querySelectorAll('#gear-attribute-filters .gear-filter-group').forEach(function (group) {
      var visibleOptions = group.querySelectorAll('.gear-filter__option:not([hidden])');
      group.classList.toggle('gear-filter-group--empty', visibleOptions.length === 0);
    });
  }

  function syncFilterOptions() {
    var filters = getActiveFilters();
    updateAttributeVisibility(filters);
    updateCategoryVisibility(filters);
    lockCategoryOptions();
  }

  function updateSidebarVisibility() {
    var layout = document.querySelector('.gear-collection-layout');
    var sidebar = document.querySelector('.gear-sidebar');
    var toolbar = document.querySelector('.gear-collection-toolbar');
    var hasCategoryGroup = !!document.querySelector('.gear-filter-group--category:not(.gear-filter-group--empty)');
    var attributeContainer = document.getElementById('gear-attribute-filters');
    var hasAttributes =
      attributeContainer &&
      attributeContainer.querySelectorAll('.gear-filter-group:not(.gear-filter-group--empty)').length > 0;
    var showSidebar = hasCategoryGroup || hasAttributes;

    if (layout) layout.classList.toggle('gear-collection-layout--no-sidebar', !showSidebar);
    if (sidebar) sidebar.classList.toggle('gear-sidebar--hidden', !showSidebar);
    if (toolbar) toolbar.classList.toggle('gear-collection-toolbar--hidden', !showSidebar);
  }

  function lockCategoryOptions() {
    var selected = getSelectedCategory();
    document.querySelectorAll('.gear-filter-group--category .gear-filter__option').forEach(function (option) {
      if (option.hidden) return;
      var input = option.querySelector('.gear-filter__checkbox--category');
      if (!input) return;
      var isSelected = selected && input.checked;
      option.classList.toggle('is-disabled', !!selected && !isSelected);
    });
  }

  function onCategoryChange(event) {
    var target = event.target;

    if (target.checked) {
      document.querySelectorAll('.gear-filter__checkbox--category:checked').forEach(function (cb) {
        if (cb !== target) cb.checked = false;
      });
    }

    lockCategoryOptions();
    runFilters();
  }

  function onAttributeChange() {
    runFilters();
  }

  function updateChosenRefinements() {
    var section = document.querySelector('.gear-chosen-refinements');
    var list = document.querySelector('.gear-chosen-refinements__list');
    var clearAll = document.querySelector('.gear-filters-clear-all');
    if (!section || !list) return;

    list.innerHTML = '';
    var refinements = [];

    getCheckedAttribute('color').forEach(function (color) {
      refinements.push({ type: 'color', label: 'Color: ' + color, value: color });
    });

    getCheckedAttribute('price').forEach(function (priceId) {
      var range = findPriceRange(priceId);
      refinements.push({
        type: 'price',
        label: 'Price: ' + (range ? range.label : priceId),
        value: priceId,
      });
    });

    getCheckedAttribute('size').forEach(function (size) {
      refinements.push({ type: 'size', label: 'Size: ' + size, value: size });
    });

    var category = getSelectedCategory();
    if (category) {
      refinements.push({
        type: 'category',
        label: 'Category: ' + category.label,
        value: category.handle,
      });
    }

    refinements.forEach(function (refinement) {
      var item = document.createElement('li');
      item.className = 'gear-chosen-refinement';

      var text = document.createElement('span');
      text.textContent = refinement.label;

      var removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'gear-chosen-refinement__remove';
      removeBtn.setAttribute('aria-label', 'Remove ' + refinement.label);
      removeBtn.textContent = '×';
      removeBtn.dataset.refinementType = refinement.type;
      removeBtn.dataset.refinementValue = refinement.value;
      removeBtn.addEventListener('click', removeRefinement);

      item.appendChild(text);
      item.appendChild(removeBtn);
      list.appendChild(item);
    });

    var hasRefinements = refinements.length > 0;
    section.hidden = !hasRefinements;
    if (clearAll) clearAll.hidden = !hasRefinements;
  }

  function removeRefinement(event) {
    var btn = event.currentTarget;
    var type = btn.dataset.refinementType;
    var value = btn.dataset.refinementValue;

    if (type === 'category') {
      var catInput = document.getElementById('cat-' + value);
      if (catInput) catInput.checked = false;
    } else {
      document.querySelectorAll('[data-filter-type="' + type + '"]').forEach(function (input) {
        if (input.value === value) input.checked = false;
      });
    }

    runFilters();
  }

  function updateFilterCount() {
    var filters = getActiveFilters();
    var count = filters.prices.length + filters.sizes.length + filters.colors.length;
    if (filters.category) count++;

    var badge = document.querySelector('[data-filter-count]');
    if (!badge) return;
    badge.textContent = count;
    badge.classList.toggle('is-visible', count > 0);
  }

  function runFilters() {
    var filters = getActiveFilters();
    var cards = getCards();
    var visible = 0;

    cards.forEach(function (card) {
      var show = cardMatchesFilters(card, filters, null);
      card.style.display = show ? '' : 'none';
      if (show) visible++;
    });

    var countEl = document.querySelector('.gear-collection-count');
    if (countEl) countEl.textContent = 'Total Items: ' + visible;

    var grid = document.querySelector('.gear-products-grid');
    if (grid) {
      var msg = grid.querySelector('.gear-empty-message');
      if (visible === 0) {
        if (!msg) {
          msg = document.createElement('p');
          msg.className = 'gear-empty-message';
          msg.style.cssText = 'grid-column:1/-1;text-align:center;padding:40px 16px;color:#666;';
          msg.textContent = 'No products match your filters. Try adjusting your selection.';
          grid.appendChild(msg);
        }
      } else if (msg) {
        msg.remove();
      }
    }

    syncFilterOptions();
    updateSidebarVisibility();
    updateChosenRefinements();
    updateFilterCount();
  }

  function clearFilters() {
    document.querySelectorAll('.gear-filter__checkbox--category:checked').forEach(function (cb) {
      cb.checked = false;
    });
    document.querySelectorAll('.gear-filter__checkbox--attribute:checked').forEach(function (cb) {
      cb.checked = false;
    });
    runFilters();
  }

  function openDrawer() {
    var drawer = document.getElementById('gear-filters-drawer');
    var overlay = document.querySelector('.gear-filters-overlay');
    var openBtn = document.querySelector('.gear-filters-open');
    if (!drawer) return;

    drawer.classList.add('is-open');
    if (overlay) {
      overlay.classList.add('is-visible');
      overlay.setAttribute('aria-hidden', 'false');
      overlay.removeAttribute('tabindex');
    }
    document.body.classList.add('gear-filters-drawer-open');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
  }

  function closeDrawer() {
    var drawer = document.getElementById('gear-filters-drawer');
    var overlay = document.querySelector('.gear-filters-overlay');
    var openBtn = document.querySelector('.gear-filters-open');
    if (!drawer) return;

    drawer.classList.remove('is-open');
    if (overlay) {
      overlay.classList.remove('is-visible');
      overlay.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('tabindex', '-1');
    }
    document.body.classList.remove('gear-filters-drawer-open');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
  }

  function initDrawer() {
    var openBtn = document.querySelector('.gear-filters-open');
    var closeBtn = document.querySelector('.gear-sidebar__close');
    var applyBtn = document.querySelector('.gear-filters-apply');
    var clearBtn = document.querySelector('.gear-filters-clear');
    var clearAllBtn = document.querySelector('.gear-filters-clear-all');
    var overlay = document.querySelector('.gear-filters-overlay');

    if (openBtn) openBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (applyBtn) applyBtn.addEventListener('click', closeDrawer);
    if (clearBtn) clearBtn.addEventListener('click', clearFilters);
    if (clearAllBtn) clearAllBtn.addEventListener('click', clearFilters);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  function init() {
    document.querySelectorAll('.gear-filter__checkbox--category').forEach(function (cb) {
      cb.addEventListener('change', onCategoryChange);
    });
    initDrawer();
    buildAttributeFilters(getCards());
    runFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
